<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4>{{'company.integrations.details.title' | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__main">
      <div *ngIf="!loading" class="integration__details vox-table">
        <table>
          <tbody>
            <tr>
              <td><span translate>company.integrations.table.name</span></td>
              <td><span>{{ integration?.name }}</span></td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.status.label</span></td>
              <td>
                <span>
                  <gdp-integration-status [status]="integration?.status"></gdp-integration-status>
                </span>
              </td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.platform</span></td>
              <td>
                <div class="platform-info flex-content">
                  <span>{{ integrationPlatform?.full_name }}</span>
                  <span translate>company.integrations.details.platform.api-filtering <gdp-status-icon
                      [isEnabled]="integrationPlatform?.api_filtering_allowed"></gdp-status-icon></span>
                  <span translate>company.integrations.details.platform.webhooks <gdp-status-icon
                      [isEnabled]="integrationPlatform?.webhooks_enabled"></gdp-status-icon></span>
                </div>
              </td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.auth-method</span></td>
              <td>
                <div class="flex-content">
                  <span>{{ 'company.integrations.details.auth-method.type' | translate }} {{ authMethodsType[integration?.authorization_method.authorization_type] }} </span>
                  <span *ngIf="authCredentials">{{ 'company.integrations.details.auth-method.credentials' | translate }} {{ authCredentials }}</span>
                  <span>{{ 'company.integrations.details.auth-method.status' | translate }} {{ authMethodStatus[integration?.authorization_method.status] }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.fields</span></td>
              <td>
                <div class="custom-fields flex-content">
                    <ng-container *ngFor="let field of customFieldsUI; let i = index">
                      <div *ngIf="field.name !== 'user mapping'">
                        <span *ngIf="isBoolean(field.value)">
                          {{field.name + ': '}} <gdp-status-icon *ngIf="isBoolean(field.value)" [isEnabled]="field.value">
                          </gdp-status-icon>
                        </span>
                        <span *ngIf="!isBoolean(field.value)">{{field.name + ': ' + field.value}} </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!customFieldsUI?.length || isUserMapping">
                      <span>-</span>
                    </ng-container>
                </div>
              </td>
            </tr>
            <tr *ngIf="mappings.length > 0">
              <td><span translate>company.integrations.table.user-mapping</span></td>
              <td>
                <ul class="user_mappings">
                  <li><b>Voxloud</b> &harr; <b>{{integrationPlatform?.full_name}}</b></li>
                  <li *ngFor="let m of mappings">
                    {{m.user?.first_name}} {{m.user?.last_name}} &harr; {{m.platform_user?.first_name}} {{m.platform_user?.last_name}}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.webhook</span></td>
              <td *ngIf="webhooks.length > 0">
                <ng-container *ngFor="let webhook of webhooks; let i = index">
                  <div class="webhook-sub flex-content">
                    <span translate>company.integrations.details.webhook.created
                      <span>{{ webhook.created_at | date: 'MM.d.yyyy h:mm'}}</span></span>
                      <span>{{'company.integrations.details.webhook.actions' | translate}} {{ webhook.webhook_events }}</span>
                  </div>
                </ng-container>
              </td>
              <td *ngIf="webhooks.length === 0">
                <span>-</span>
              </td>
            </tr>
            <tr>
              <td><span translate>company.integrations.table.contacts</span></td>
              <td *ngIf="!loadingContacts"><span>{{ contactsCount }}</span></td>
              <td *ngIf="loadingContacts">
                <ngx-skeleton-loader [theme]="{'height': '36px', 'width': '36px', 'margin-bottom': '-8px'}">
                </ngx-skeleton-loader>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="loading">
        <ngx-skeleton-loader [theme]="{'height': '500px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
